import React, { useRef } from 'react';
import { createPortal } from 'react-dom';
/* [2026-09-27] 알림창 로고를 그 사이트의 로고로 통일 — 상단 메뉴·홈·슬롯·출석체크·게임 검색 등 어디서 뜨든 같은 로고.
   WHY: 종전에는 로고를 넘겨주는 곳(상단 메뉴의 로그아웃·포인트 전환 알림창)만 사이트 로고였고, 넘기지 않는 곳
     (홈·슬롯의 게임 실행 실패, 출석체크 결과, 루미나 게임 검색)은 빌드 속 NM 로고가 떴다.
     그래서 city·miracle·로얄 회원이 같은 사이트 안에서 자기 운영사 로고와 NM 로고를 섞어 봤다(2026-09-27 실측).
   규칙: 로고를 고르는 규칙은 상단 메뉴와 같은 utils/logoHelper.getLogoUrl 하나(디자인설정 "통합 로고" → 메인 로고)를 쓴다.
     [2026-09-28] 사이트 로고를 모르면(첫 화면 직후·디자인설정에 로고 없음) 넘겨받은 로고, 그것도 없으면 로고 없이 띄운다.
     WHY: 예전 마지막 기본값(빌드 속 NM 로고)은 city·miracle·로얄 사이트에서는 남의 로고였다. 상단 메뉴도 이때는 로고를
     비운다(logoHelper 가 null 을 주면 그림을 그리지 않는 것이 약속).
   로고 크기: 디자인설정 > 위치별 크기 설정 > "알림창 (Modal)" 값을 상단 메뉴·푸터·로그인 로고와 같은 규칙(getLogoStyle —
     값은 최대 가로·세로)으로 적용한다. [2026-09-28] 종전에는 이 틀만 그 설정을 읽지 않아 설정을 바꿔도 알림창 로고는 그대로였다. */
import { useDesignTemplate } from '../../contexts/DesignTemplateContext';
import { getLogoUrl, getLogoStyle } from '../../utils/logoHelper';
import { useDialogKeyboard } from '../../utils/dialogKeyboard';
import './Modal.css';

const Modal = ({
  id,
  isOpen,
  onClose,
  text,
  type = 'alert', // 'alert' or 'confirm'
  onConfirm,
  logoSrc
}) => {
  // 훅은 조기 반환보다 먼저 부른다(React 훅 호출 순서 규칙)
  const designTemplate = useDesignTemplate();
  const containerRef = useRef(null);
  // [2026-09-28] 브라우저 기본 알림창처럼 키보드로 — 열리면 "확인"에 초점, Esc = 닫기(확인창은 취소),
  //   떠 있는 동안 키가 뒤 화면으로 새지 않음(utils/dialogKeyboard.js)
  useDialogKeyboard(isOpen, containerRef, onClose, `${type}\n${text}`);

  if (!isOpen) return null;

  const resolvedLogoSrc = getLogoUrl(designTemplate, 'main') || logoSrc || null;

  const handleConfirm = () => {
    if (onConfirm) onConfirm();
    onClose();
  };

  const modalContent = (
    <div className="modal" id={id} ref={containerRef}>
      <div className="modal-content">
        {resolvedLogoSrc && (
          <div className="modal-logo">
            <img src={resolvedLogoSrc} alt="로고" style={getLogoStyle(designTemplate, 'modal')} />
          </div>
        )}
        {/* [2026-09-27] 줄바꿈(\n)을 브라우저 기본 알림창처럼 살린다 — 사이트 알림 다리로 옮겨 온 안내에 두 줄 문구가 있다 */}
        <div className="modal-text" style={{ whiteSpace: 'pre-line' }}>{text}</div>
        {type === 'alert' ? (
          <button className="modal-confirm" onClick={handleConfirm}>
            확인
          </button>
        ) : (
          <div className="modal-buttons">
            <button className="modal-confirm" onClick={handleConfirm}>
              확인
            </button>
            <button className="modal-cancel" onClick={onClose}>
              취소
            </button>
          </div>
        )}
      </div>
    </div>
  );

  // Portal을 사용하여 document.body에 직접 렌더링
  return createPortal(modalContent, document.body);
};

export default Modal;
